import { percentageLevels } from "utils/indicator/indicatorSettings";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";
import styles from "./FederationLoadingRow.module.styl";
import Chart from "react-apexcharts";
import { exact, number, string } from "prop-types";
import React from "react";

export default function FederationLoadingRow({ sportObjectLoading }) {
    const indicatorStyle = percentageLevels.indicatorColor(sportObjectLoading.loading);
    const options = chartOptions(indicatorStyle, "18px");
    const series = [sportObjectLoading.loading];

    return (
        <div className={styles.row}>
            <div className={styles.buildingName}>{sportObjectLoading.name}</div>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

FederationLoadingRow.propTypes = {
    sportObjectLoading: exact({
        id: number.isRequired,
        name: string.isRequired,
        loading: number.isRequired,
    }),
};
